import { ALERT_SEVERITY_MAP, AlertSeverity, AlertType } from "@core/apis/PropAI/types/alerts.type";

import { CheckItem } from "./CheckItemsList";

export type AlertConfigBase = {
  title: string;
  reasonIntro: string;
  checkItems: CheckItem[];
};

export type AlertConfig = AlertConfigBase & {
  severity: AlertSeverity;
};

/**
 * Base config - severity is derived from ALERT_SEVERITY_MAP
 * Right now the 'summary' from the API is populating the description field, when that is fix - update here
 * We will also need to update the AlertsTable.tsx file to adjust for this - description={alert.summary}
 */
const ALERT_CONFIG_BASE: Record<AlertType, AlertConfigBase> = {
  too_little_temperature_data: {
    title: "alert_too_little_temperature_data_title",
    reasonIntro: "alert_too_little_temperature_data_reason_intro",
    checkItems: [
      { text: "alert_too_little_temperature_data_check_location" },
      { text: "alert_too_little_temperature_data_check_battery" },
      { text: "alert_too_little_temperature_data_check_connectivity" },
    ],
  },
  inactive_radiator_system_sensor: {
    title: "alert_inactive_radiator_system_sensor_title",
    reasonIntro: "",
    checkItems: [
      { text: "alert_inactive_radiator_system_sensor_check_integration" },
      { text: "alert_inactive_radiator_system_sensor_check_damaged" },
    ],
  },
  control_signal_problem: {
    title: "alert_control_signal_problem_title",
    reasonIntro: "",
    checkItems: [{ text: "alert_control_signal_problem_check_connection" }],
  },
  building_control_problem: {
    title: "alert_building_control_problem_title",
    reasonIntro: "",
    checkItems: [
      { text: "alert_building_control_problem_check_pump_stop" },
      { text: "alert_building_control_problem_check_connection" },
      { text: "alert_building_control_problem_check_valve" },
      { text: "alert_building_control_problem_check_temp_meter" },
    ],
  },
  building_too_cold: {
    title: "alert_building_too_cold_title",
    reasonIntro: "",
    checkItems: [
      { text: "alert_building_too_cold_check_climate_tab" },
      { text: "alert_building_too_cold_check_pump_stop" },
      { text: "alert_building_too_cold_check_supply_temp" },
      { text: "alert_building_too_cold_check_few_apartments" },
      { text: "alert_building_too_cold_check_most_apartments" },
    ],
  },
  building_too_warm: {
    title: "alert_building_too_warm_title",
    reasonIntro: "",
    checkItems: [
      { text: "alert_building_too_warm_check_climate_tab" },
      { text: "alert_building_too_warm_check_supply_temp" },
      { text: "alert_building_too_warm_check_few_apartments" },
      { text: "alert_building_too_warm_check_most_apartments" },
    ],
  },
};

/**
 * Full alert config with severity derived from ALERT_SEVERITY_MAP
 */
export const ALERT_CONFIG: Record<AlertType, AlertConfig> = Object.fromEntries(
  Object.entries(ALERT_CONFIG_BASE).map(([key, config]) => [
    key,
    { ...config, severity: ALERT_SEVERITY_MAP[key as AlertType] },
  ])
) as Record<AlertType, AlertConfig>;
